import dayjs from 'dayjs';

export const autoFilledCheckInDate = () => dayjs().add(14, 'day');
export const autoFilledCheckOutDate = () => dayjs().add(15, 'day');

export const autoFilledCheckInToday = () => dayjs();
export const autoFilledCheckOutTomorrow = () => dayjs().add(1, 'day');

// adding 365 days from today
export const latestSelectableDate = () => dayjs().add(365, 'day');
